import PathListDto from "../pathmodule/PathListDto";
import DataSourceListDto from "./DataSourceListDto";

class DataProviderListDto {
    Key: string;
    Id: number;
    Name: string;
    Type: string;

    DataSource: DataSourceListDto | null;
    PathDataTable: PathListDto | null;

    constructor(id: number, name: string, type: string, dataSource: DataSourceListDto | null, pathDataTable: PathListDto | null) {
        this.Key = id + "_" + type;
        this.Id = id;
        this.Name = name;
        this.Type = type;
        this.DataSource = dataSource;
        this.PathDataTable = pathDataTable;
    }
}

export default DataProviderListDto;
